import { render } from "./Segments.vue?vue&type=template&id=547cc8b4&scoped=true&lang=pug"
import script from "./Segments.vue?vue&type=script&lang=js"
export * from "./Segments.vue?vue&type=script&lang=js"

import "./Segments.vue?vue&type=style&index=0&id=547cc8b4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547cc8b4"]])

export default __exports__